<div class="leitor-side-menu-mobile-container">
  <div class="leitor-side-menu-mobile">
    <button
      mat-icon-button
      class="leitor-side-menu-mobile-button"
      aria-label="Open BottomSheet"
      (click)="toggleOpenBottomSheet(true)"
    >
      <mat-icon svgIcon="bars" class="leitor-side-menu-mobile-icon"></mat-icon>
    </button>
  </div>
</div>
